import { useState, useCallback, useEffect } from 'react';
import { useClientSize, useOnElementResize } from '@anton.bobrov/react-hooks';
import { joinCoordsInRoundedPath } from './joinCoordsInRoundedPath.js';

function useSvgLines({ svgRef, refElements }) {
  const { clientWidth, clientHeight } = useClientSize(svgRef);
  const [lines, setLines] = useState([]);
  const resize = useCallback(() => {
    if (!svgRef.current) {
      return;
    }
    const radius = 10;
    const svgBounding = svgRef.current.getBoundingClientRect();
    const array = refElements.map((element, index) => {
      const elementBounding = element.getBoundingClientRect();
      const y2 = elementBounding.top - svgBounding.top + elementBounding.height / 2;
      const y3 = y2;
      const x3 = radius;
      const coords = [
        { x: 0, y: 0 },
        { x: 0, y: y2 },
        { x: x3, y: y3 }
      ];
      const path = joinCoordsInRoundedPath(coords, radius);
      return {
        key: index,
        path,
        refElement: element,
        length: y3 + 7.44,
        coords
      };
    });
    setLines(array);
  }, [refElements, svgRef]);
  useOnElementResize(svgRef, resize);
  useEffect(() => resize(), [resize]);
  return {
    width: clientWidth,
    height: clientHeight,
    lines
  };
}

export { useSvgLines };
//# sourceMappingURL=useSvgLines.js.map
